import React from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";

const DPMM_OPTIONS = [
  { label: '6 dpmm (152 dpi)', value: '6dpmm' },
  { label: '8 dpmm (203 dpi)', value: '8dpmm' },
  { label: '12 dpmm (300 dpi)', value: '12dpmm' },
  { label: '24 dpmm (600 dpi)', value: '24dpmm' },
];

export default function CommandButtons({
  handleTagSelect,
  tagsList,
  currentTag,
  widthCm,
  setWidthCm,
  heightCm,
  setHeightCm,
  dpmm,
  setDpmm,
  renderPreview,
}) {
  return (
    <>
      <Row style={{ marginBottom: 16 }}>
        <Col lg={12}>
          <h5 style={{ fontWeight: 600 }}>Visualizador de Etiqueta ZPL</h5>
          <small className="text-muted">
            Insira o código ZPL abaixo e clique em "Renderizar" para visualizar a etiqueta.
          </small>
        </Col>
      </Row>

      <Row style={{ marginBottom: 16 }}>
        <Col md={12}>
          <FormGroup>
            <Label>Modelo de etiqueta</Label>
            <Input
              type="select"
              value={currentTag}
              onChange={(e) => handleTagSelect(e.target.value)}
            >
              <option value="" disabled>Selecione um modelo...</option>
              {tagsList.map((tag) => (
                <option key={tag.id} value={tag.id}>{tag.description}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row style={{ marginBottom: 16 }}>
        <Col md={3}>
          <FormGroup>
            <Label>Largura (cm)</Label>
            <Input
              type="number"
              min="1"
              max="50"
              step="0.5"
              value={widthCm}
              onChange={(e) => setWidthCm(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Altura (cm)</Label>
            <Input
              type="number"
              min="1"
              max="50"
              step="0.5"
              value={heightCm}
              onChange={(e) => setHeightCm(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Resolução</Label>
            <Input
              type="select"
              value={dpmm}
              onChange={(e) => setDpmm(e.target.value)}
            >
              {DPMM_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <FormGroup style={{ width: '100%' }}>
            <Button color="primary" onClick={() => renderPreview()} style={{ width: '100%' }}>
              Renderizar
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}
